/**
 * Permissions description
 * @see https://github.com/VirtusLab-Nexelem/lemma/blob/dev/conf/messages
 */
export enum PERMS {
  // API Module
  API_1 = 'API-1', // Raportowanie produkcji przez API
  API_2 = 'API-2', // Pobór danych z systemu

  // Barcode Module
  BAR_1 = 'BAR-1', // Dostęp do modułu kodów kreskowych
  BAR_2 = 'BAR-2', // Obsługa skanowania kodów kreskowych

  // Calculation Module
  CALC_1 = 'CALC-1', // Dostęp do modułu kalkulacji

  // Contractors Module
  CON_1 = 'CON-1', // Moduł kontrahentów
  CON_2 = 'CON-2', // Wybieranie nieaktywnych kontrahentów
  CON_3 = 'CON-3', // Przypisywanie siebie jako opiekuna handlowego, gdy opiekun handlowy nie jest jeszcze przypisany
  CON_4 = 'CON-4', // Przypisywanie siebie jako opiekuna handlowego
  CON_5 = 'CON-5', // Przypisywanie opiekuna handlowego
  CON_6 = 'CON-6', // Odwoływanie opiekuna handlowego
  CON_7 = 'CON-7', // Bycie przypisanym jako opiekun handlowy
  CON_8 = 'CON-8', // Wyświetlanie kontrahentów

  // Documents Module
  DOC_1 = 'DOC-1', // Dostęp do dokumentów
  DOC_2 = 'DOC-2', // Generacja karty produkcyjnej
  DOC_3 = 'DOC-3', // Generacja specyfikacji dla klienta
  DOC_4 = 'DOC-4', // Generacja podsumowania zadań produkcji
  DOC_5 = 'DOC-5', // Generacja podsumowania zadań specyfikacji
  DOC_6 = 'DOC-6', // Generacja podsumowania przedziałów dla partii
  DOC_7 = 'DOC-7', // Generacja podsumowania produkcji dla partii
  DOC_8 = 'DOC-8', // Generacja podsumowania kart załadowania partii
  DOC_9 = 'DOC-9', // Generacja podsumowania kosztów
  DOC_10 = 'DOC-10', // Generacja podsumowania zużycia surowców przez linie produkcyjne

  // Events Module
  EV_1 = 'EV-1', // Zarządzanie subskrypcjami dotyczącymi zamówień
  EV_2 = 'EV-2', // Zarządzanie subskrypcjami dotyczącymi ofert
  EV_3 = 'EV-3', // Zarządzanie subskrypcjami dotyczącymi specyfikacji produkcji
  EV_4 = 'EV-4', // Zarządzanie subskrypcjami dotyczącymi partii produkcyjnych
  EV_5 = 'EV-5', // Dostęp do zarządzania subskrypcjami
  EV_6 = 'EV-6', // Edycja subskrypcji w widoku ogólnym
  EV_7 = 'EV-7', // Wyświetlanie zasubskrybowanych użytkowników
  EV_8 = 'EV-8', // Zarządzanie subskrypcjami dotyczącymi dokumentów
  EV_9 = 'EV-9', // Zarządzanie subskrypcjami dotyczącymi raportów
  EV_10 = 'EV-10', // Zarządzanie subskrypcjami dotyczącymi spełnień i zapotrzebowań
  EV_11 = 'EV-11', // Zarządzanie subskrypcjami dotyczącymi zadań specyfikacji

  // Global Module
  GLO_1 = 'GLO-1', // Dostęp do zadań administracyjnych
  GLO_2 = 'GLO-2', // Możliwość synchronizacji wszystkich dokumentów PWP
  GLO_3 = 'GLO-3', // Ustawianie daty i godziny w pomiarach

  // Material Movements Module
  MM_1 = 'MM-1', // Dostęp do modułu transportu wewnętrznego

  // Items/Products Module
  ITM_1 = 'ITM-1', // Tworzenie typów produktów
  ITM_2 = 'ITM-2', // Dostęp do katalogu produktów
  ITM_3 = 'ITM-3', // Wyszukiwanie produktów po właściwościach
  ITM_4 = 'ITM-4', // Wybieranie nieaktywnych produktów
  ITM_5 = 'ITM-5', // Moduł produktów
  ITM_6 = 'ITM-6', // Wyświetlanie listy typów produktów
  ITM_7 = 'ITM-7', // Wyświetlanie listy typów pakowania
  ITM_8 = 'ITM-8', // Ustawianie cen dla grup produktów
  ITM_9 = 'ITM-9', // Oznaczanie przedmiotów jako nieaktywne
  ITM_10 = 'ITM-10', // Oznaczanie zestawów własności jako nieaktywne
  ITM_11 = 'ITM-11', // Oznaczanie wariantów typów jako nieaktywne
  ITM_12 = 'ITM-12', // Ustawienia produktów
  ITM_13 = 'ITM-13', // Cenniki
  ITM_14 = 'ITM-14', // Tworzenie wewnętrznych typów produktów
  ITM_15 = 'ITM-15', // Tworzenie zewnętrznych typów produktów
  ITM_16 = 'ITM-16', // Eksportowanie produktów

  // Machines Module
  MACH_1 = 'MACH-1', // Moduł maszyn
  MACH_2 = 'MACH-2', // Przypisywanie pracowników do maszyn
  MACH_3 = 'MACH-3', // Listowanie typów maszyn
  MACH_4 = 'MACH-4', // Listowanie parametrów maszyn
  MACH_5 = 'MACH-5', // Stany maszyn
  MACH_6 = 'MACH-6', // Szczegóły maszyny
  MACH_7 = 'MACH-7', // Kalendarz maszyny
  MACH_8 = 'MACH-8', // Dostęp do widoku listy maszyn

  // Marketing Rules Module
  MR_1 = 'MR-1', // Dostęp do modułu reguł marketingowych

  // Offers Module
  OFF_1 = 'OFF-1', // Dostęp do modułu ofert
  OFF_2 = 'OFF-2', // Tworzenie zamówienia z oferty
  OFF_4 = 'OFF-4', // Tworzenie ofert
  OFF_5 = 'OFF-5', // Edytowanie ofert
  OFF_6 = 'OFF-6', // Tworzenie nowych produktów

  // Orders Module
  ORD_1 = 'ORD-1', // Dostęp do modułu zamówień
  ORD_2 = 'ORD-2', // Anulowanie pozycji zamówienia
  ORD_3 = 'ORD-3', // Tworzenie dokumentów WZ z zamówienia
  ORD_4 = 'ORD-4', // Anulowanie zamówień
  ORD_5 = 'ORD-5', // Dostęp do pozycji zamówienia
  ORD_6 = 'ORD-6', // Wyświetlanie listy zamówień
  ORD_7 = 'ORD-7', // Zatwierdzanie zamówień przekraczających limit kupiecki
  ORD_9 = 'ORD-9', // Wysyłanie odpowiedzi na zamówienie przez ECOD

  // Packing Module
  PCK_1 = 'PCK-1', // Pakowanie folii
  PCK_5 = 'PCK-5', // Pakowanie długich przedmiotów
  PCK_6 = 'PCK-6', // Pakowanie podstawowe
  PCK_8 = 'PCK-8', // Pakowanie szpula stożkowa
  PCK_9 = 'PCK-9', // Pakowanie szpula plastikowa
  PCK_10 = 'PCK-10', // Pakowanie szpula stalowa 630
  PCK_11 = 'PCK-11', // Pakowanie szpula stalowa 800
  PCK_12 = 'PCK-12', // Pakowanie beczka drewniana
  PCK_13 = 'PCK-13', // Pakowanie karton
  PCK_14 = 'PCK-14', // Pakowanie oktabin
  PCK_15 = 'PCK-15', // Pakowanie krążek
  PCK_16 = 'PCK-16', // Pakowanie etykiet

  // Production Orders Module
  PORD_1 = 'PORD-1', // Dostęp do zleceń produkcyjnych
  PORD_2 = 'PORD-2', // Dostęp do kalkulacji w zleceniach produkcyjnych
  PORD_3 = 'PORD-3', // Korekta ilości w zleceniach produkcyjnych
  PORD_40 = 'PORD-40', // Listowanie wszystkich partii produkcyjnych
  PORD_4 = 'PORD-4', // Dostęp do widoku zleceń produkcyjnych

  // Production Module
  PROD_1 = 'PROD-1', // Dostęp do produkcji
  PROD_4 = 'PROD-4', // Dostęp do raportów produkcji innych użytkowników
  PROD_5 = 'PROD-5', // Anulowanie nowych partii produkcyjnych
  PROD_6 = 'PROD-6', // Akceptowanie raportów jakości
  PROD_7 = 'PROD-7', // Raportowanie wszystkich partii produkcyjnych
  PROD_8 = 'PROD-8', // Możliwość wprowadzania korekt do raportów ilości
  PROD_9 = 'PROD-9', // Możliwość wprowadzania korekt do raportów odpadu
  PROD_10 = 'PROD-10', // Wypełnianie raportu receptury ze specyfikacji
  PROD_11 = 'PROD-11', // Zapisywanie (bez zakańczania) raportów produkcji
  PROD_12 = 'PROD-12', // Edytowanie sfinalizowanych raportów
  PROD_13 = 'PROD-13', // Edytowanie raportów innych użytkowników
  PROD_14 = 'PROD-14', // Wypełnianie raportu receptury z poprzedniego raportu
  PROD_15 = 'PROD-15', // Wczytywanie raportu pakowania ze specyfikacji
  PROD_16 = 'PROD-16', // Wypełnianie raportu pakowania z poprzedniego raportu
  PROD_17 = 'PROD-17', // Dodawanie parametrów jakości
  PROD_18 = 'PROD-18', // Dodawanie pomiarów jakościowych
  PROD_19 = 'PROD-19', // Edycja w "Kontroli jakości"
  PROD_20 = 'PROD-20', // Usuwanie pomiarów jakości
  PROD_21 = 'PROD-21', // Zgłaszanie problemów w badaniu jakości
  PROD_22 = 'PROD-22', // Zapisywanie pustych raportów odpadów
  PROD_23 = 'PROD-23', // Dostęp do szczegółów partii produkcyjnej
  PROD_24 = 'PROD-24', // Dostęp do badań jakości
  PROD_25 = 'PROD-25', // Raportowanie produkcji
  PROD_26 = 'PROD-26', // Generowanie raportu jakości
  PROD_27 = 'PROD-27', // Kopiowanie partii produkcyjnej
  PROD_28 = 'PROD-28', // Zmiana docelowego magazynu dokumentów
  PROD_29 = 'PROD-29', // Usuwanie parametru jakości
  PROD_30 = 'PROD-30', // Dostęp do raportu przestoju
  PROD_31 = 'PROD-31', // Ładowanie składników spoza receptury w raporcie ładowania
  PROD_32 = 'PROD-32', // Akceptację partii produkcyjnej
  PROD_33 = 'PROD-33', // Cofnięcie akceptacji partii produkcyjnej
  PROD_34 = 'PROD-34', // Lista jednostek produkcyjnych
  PROD_35 = 'PROD-35', // Automatyczny raport receptury
  PROD_36 = 'PROD-36', // Eksportowanie do XLS
  PROD_37 = 'PROD-37', // Przenoszenie partii produkcyjnej do magazynu
  PROD_38 = 'PROD-38', // Listowanie pracowników produkcji
  PROD_39 = 'PROD-39', // Wykonywanie akcji na panelu produkcji
  PROD_40 = 'PROD-40', // Listowanie wszystkich partii produkcyjnych
  PROD_41 = 'PROD-41', // Anulowanie partii produkcyjnych zaplanowanych do produkcji
  PROD_42 = 'PROD-42', // Anulowanie partii produkcyjnych w kolejce
  PROD_43 = 'PROD-43', // Edytowanie kart zużycia składników
  PROD_44 = 'PROD-44', // Dodawanie odnośnika do jednostki produkcyjnej w karcie ładowania
  PROD_45 = 'PROD-45', // Podział partii produkcyjnej
  PROD_46 = 'PROD-46', // Archiwizowanie partii produkcyjnych bez spełnionych norm jakości
  PROD_47 = 'PROD-47', // Wyświetlanie oczekiwanej realizacji na planszy produkcyjnej
  PROD_48 = 'PROD-48', // Anulowanie wielu partii produkcyjnych jednocześnie
  PROD_49 = 'PROD-49', // Manualne ustawianie czasu rozpoczęcia i zakończenia produkcji
  PROD_50 = 'PROD-50', // Cofanie partii z kolumny 'Do produkcji' do 'Do specyfikacji'
  PROD_51 = 'PROD-51', // Cofanie partii z kolumny 'W kolejce' do 'Do produkcji'

  // Production Specification Module
  PRODSPEC_1 = 'PRODSPEC-1', // Wczytanie specyfikacji produkcji z szablonu
  PRODSPEC_2 = 'PRODSPEC-2', // Zapisanie specyfikacji produkcji jako szablon
  PRODSPEC_3 = 'PRODSPEC-3', // Weryfikacja specyfikacji produkcji
  PRODSPEC_4 = 'PRODSPEC-4', // Dostęp do sekcji pomiarów maszyn
  PRODSPEC_5 = 'PRODSPEC-5', // Wyświetlanie zadań specyfikacji
  PRODSPEC_6 = 'PRODSPEC-6', // Zmiana typu przepisu
  PRODSPEC_7 = 'PRODSPEC-7', // Akceptacja specyfikacji produkcji
  PRODSPEC_8 = 'PRODSPEC-8', // Dostęp do specyfikacji produkcji po akceptacji
  PRODSPEC_9 = 'PRODSPEC-9', // Dostęp do tagów specyfikacji
  PRODSPEC_10 = 'PRODSPEC-10', // Edytowanie sekcji maszyn
  PRODSPEC_11 = 'PRODSPEC-11', // Dostęp do sekcji pomiarów produkcji
  PRODSPEC_12 = 'PRODSPEC-12', // Blokowanie zmiany wyboru wariantów w recepturze
  PRODSPEC_13 = 'PRODSPEC-13', // Akceptacja ilości w jednostce receptury

  // Production Board Module
  PDB_2 = 'PDB-2', // Dostęp do widoku specyfikowania
  PDB_3 = 'PDB-3', // Dostęp do widoku planowania kanban
  PDB_4 = 'PDB-4', // Dostęp do widoku realizacji
  PDB_5 = 'PDB-5', // Dostęp do widoku archiwizacji
  PDB_6 = 'PDB-6', // Dostęp do widoku pełnej planszy produkcyjnej
  PDB_7 = 'PDB-7', // Dostęp do widoku parti produkcyjnej z wyszczególnionym kolorem i pakowaniem
  PDB_8 = 'PDB-8', // Dostęp do przycisku automatycznego ustawiania kolejności w kolumnie 'Do specyfikacji'
  PDB_9 = 'PDB-9', // Zmiana nazwy 'Seria' na 'Partia' w raporcie jakości
  PDB_10 = 'PDB-10', // Możliwość zmiany kolejności partii w kolumnie 'W kolejce'
  PDB_11 = 'PDB-11', // Dostęp do wyświetlania minimalnego poziomu szczegółów partii produkcyjnej
  PDB_12 = 'PDB-12', // Dostęp do wyświetlania podstawowego poziomu szczegółów partii produkcyjnej
  PDB_13 = 'PDB-13', // Dostęp do wyświetlania pełnego poziomu szczegółów partii produkcyjnej
  PDB_14 = 'PDB-14', // Dostęp do kolorowania partii produkcyjnych
  PDB_15 = 'PDB-15', // Dostęp do rozszerzonej funkcjonalności filtrów

  // Batch Module
  BATCH_1 = 'BATCH-1', // Alternatywne nazwy serii
  BATCH_2 = 'BATCH-2', // Dostęp do raportu produkcji dla serii

  // Quality Supply Module
  QS_1 = 'QS-1', // Dodawanie parametrów jakości
  QS_2 = 'QS-2', // Widok raportów jakości dostaw
  QS_3 = 'QS-3', // Edycja i zapis raportów jakości dostaw
  QS_4 = 'QS-4', // Usuwanie kart dostawy
  QS_7 = 'QS-7', // Karty dostaw
  QS_8 = 'QS-8', // Numery pozycji na liście kart dostaw

  // Quality Module
  QUA_1 = 'QUA-1', // Dostęp do jakości

  // Recipe Module
  RCP_1 = 'RCP-1', // Receptura procentowa
  RCP_2 = 'RCP-2', // Receptura sztukowa
  RCP_3 = 'RCP-3', // Receptura pasemkowa
  RCP_4 = 'RCP-4', // Receptura skrętkowa
  RCP_5 = 'RCP-5', // Receptura drutowa
  RCP_6 = 'RCP-6', // Receptura kablowa
  RCP_7 = 'RCP-7', // Receptura podskrętkowa
  RCP_8 = 'RCP-8', // Receptura sztukowo-procentowa
  RCP_9 = 'RCP-9', // Receptura drukowania
  RCP_10 = 'RCP-10', // Receptura formy drukowej
  RCP_11 = 'RCP-11', // Receptura przewijania

  // Shipping Module
  SHP_1 = 'SHP-1', // Dostęp do modułu spedycji
  SHP_2 = 'SHP-2', // Planowanie wysyłek
  SHP_3 = 'SHP-3', // Skrócone wysyłanie
  SHP_4 = 'SHP-4', // Podsumowanie tras
  SHP_5 = 'SHP-5', // Tworzenie dokumentów WZ

  // Import Module
  IMP_1 = 'IMP-1', // Importowanie zamówień z pliku CSV
  IMP_2 = 'IMP-2', // Importowanie zamówień ECOD
  IMP_3 = 'IMP-3', // Importowanie zamówień z faktur proforma

  // Specification Module
  SPEC_1 = 'SPEC-1', // Dostęp do specyfikacji
  SPEC_2 = 'SPEC-2', // Domyślna receptura
  SPEC_4 = 'SPEC-4', // Ilość w specyfikacji
  SPEC_5 = 'SPEC-5', // Usuwanie wzorców specyfikacji
  SPEC_6 = 'SPEC-6', // Pakowanie w zamówieniu
  SPEC_7 = 'SPEC-7', // Wyświetlanie listy typów receptur
  SPEC_8 = 'SPEC-8', // Wyświetlanie listy szablonów specyfikacji dla wariantu
  SPEC_9 = 'SPEC-9', // Zadanie specyfikacji
  SPEC_10 = 'SPEC-10', // Zmiana papieru
  SPEC_11 = 'SPEC-11', // Zmiana wykrojnika
  SPEC_12 = 'SPEC-12', // Wyświetlanie listy szablonów specyfikacji dla właściwości maszyny
  SPEC_13 = 'SPEC-13', // Wyświetlanie listy szablonów specyfikacji dla tagów produkowanych towarów
  SPEC_14 = 'SPEC-14', // Edycja i wyświetlanie ceny w zadaniu specyfikacji
  SPEC_15 = 'SPEC-15', // Dostęp do sekcji kontroli jakości w specyfikacji
  SPEC_16 = 'SPEC-16', // Generowanie kosztów w zadaniu specyfikacji
  SPEC_17 = 'SPEC-17', // Edytowanie specyfikacji klienta dla zaplanowanych przedmiotów zamówienia
  SPEC_18 = 'SPEC-18', // Edytowanie parametrów pomiarowych
  SPEC_19 = 'SPEC-19', // Edytowanie norm pomiarowych
  SPEC_20 = 'SPEC-20', // Historia edycji receptury

  // Supply Orders Module
  SUP_1 = 'SUP-1', // Dostęp do modułu dostaw
  SUP_2 = 'SUP-2', // Dostęp do managera zamówień
  SUP_3 = 'SUP-3', // Możliwość akceptacji zamówień dostaw

  // Warranty Claims Module
  WC_1 = 'WC-1', // Moduł reklamacji

  // Document Status Module
  DST_1 = 'DST-1', // Wyświetlanie statusu dokumentów
  DST_2 = 'DST-2', // Użycie serwera Ftp
  DST_3 = 'DST-3', // Usuwanie plików z serwera Ftp

  // Tickets Module
  TIC_1 = 'TIC-1', // Wyświetlanie listy zadań

  // User Management Module
  UM_1 = 'UM-1', // Zmiana ustawień
  UM_2 = 'UM-2', // Tworzenie kont
  UM_3 = 'UM-3', // Wyświetlanie listy użytkowników
  UM_4 = 'UM-4', // Edycja identyfikatora RFID użytkownika

  // Production Units Module
  UNITS_1 = 'UNITS-1', // Dostęp do modułu jednostek produkcji
  UNITS_2 = 'UNITS-2', // Przepakowywanie jednostek produkcji

  // ERP Module
  ERP_1 = 'ERP-1', // Wyświetlanie listy synchronizacji
  ERP_2 = 'ERP-2', // Ręczna synchronizacja z ERP

  // Sales Module
  SAL_1 = 'SAL-1', // Podstawowe funkcjonalności modułów sprzedażowych
  SAL_2 = 'SAL-2', // Możliwość ustawienia jako osoba odpowiedzialna za ofertę/zamówienie
  SAL_3 = 'SAL-3', // Dostęp do danych finansowych w zamówieniu lub ofercie

  // Activities Module
  ACT_1 = 'ACT-1', // Lista aktywności
  ACT_2 = 'ACT-2', // Usuwanie aktywności
  ACT_3 = 'ACT-3', // Edycja aktywności

  // Estimation Module
  EST_1 = 'EST-1', // Dostęp do modułu estymacji
  EST_2 = 'EST-2', // Konfiguracja użycia kalendarza w procesie estymacji produkcji

  // Stock Module
  STOCK_1 = 'STOCK-1', // Dostęp do modułu stanów magazynowych

  // Measurements Module
  MEAS_1 = 'MEAS-1', // Edycja urządzeń pomiarowych

  // Reports Module
  REP_1 = 'REP-1', // Edycja przyczyn odpadów
  REP_2 = 'REP-2', // Edycja przyczyn przestojów maszyn

  // Presentation Module
  PRE_1 = 'PRE-1', // Możliwość szybkiego ukończenia produkcji
  PRE_2 = 'PRE-2', // Szybkie rozpoczynanie zlecenia produkcyjnego

  // Workstation Module
  WRKST_1 = 'WRKST-1', // Stacje robocze
  WRKST_2 = 'WRKST-2', // Ręczna zmiana daty startu produkcji
  WRKST_3 = 'WRKST-3', // Raportowanie w imieniu innych
  WRKST_4 = 'WRKST-4', // Dostęp do edycji BOM w zadaniu specyfikacji

  // Stocktaking Module
  STT_1 = 'STT-1', // Akceptacja inwentaryzacji
  STT_2 = 'STT-2', // Inwentaryzacja

  // Workers Module
  WOR_1 = 'WOR-1', // Dostęp do modułu pracowników

  // Uprawnienia ogólne
  /** Widok pulpitu */
  PERM_1 = 'PERM-1',
  /** Widok planu produkcji */
  PERM_2 = 'PERM-2',
  /** Widok trybu przydzielania */
  PERM_3 = 'PERM-3',
  /** Edycja planu produkcji */
  PERM_4 = 'PERM-4',
  /** Użycie algorytmu planowania */
  PERM_5 = 'PERM-5',
  /** Dodawanie do planu */
  PERM_6 = 'PERM-6',
  /** Widok szczegółów partii produkcyjnej */
  PERM_7 = 'PERM-7',
  /** Widok szczegółów produktu */
  PERM_8 = 'PERM-8',
  /** Widok grafu identyfikowalności */
  PERM_9 = 'PERM-9',
  /** Widok szczegółów zlecenia produkcyjnego */
  PERM_10 = 'PERM-10',
  /** Widok listy symulacji planu produkcji */
  PERM_11 = 'PERM-11',
  /** Edycja symulacji planu produkcji */
  PERM_12 = 'PERM-12',
  /** Publikowanie symulacji planu produkcji */
  PERM_13 = 'PERM-13',
  /** Widok listy zleceń produkcyjnych */
  PERM_14 = 'PERM-14',
  /** Widok szczegółów zamówienia sprzedaży */
  PERM_15 = 'PERM-15',
  /** Edycja zlecenia produkcyjnego */
  PERM_16 = 'PERM-16',
  /** Tworzenie zlecenia produkcyjnego */
  PERM_17 = 'PERM-17',
  /** Widok listy partii produkcyjnych */
  PERM_18 = 'PERM-18',
  /** Akceptacja partii produkcyjnej */
  PERM_19 = 'PERM-19',
  /** Widok raportów produkcji */
  PERM_20 = 'PERM-20',
  /** Widok raportów przestojów produkcji */
  PERM_21 = 'PERM-21',
  /** Edycja raportu produkcji */
  PERM_22 = 'PERM-22',
  /** Edycja raportu innego użytkownika */
  PERM_23 = 'PERM-23',
  /** Edycja raportu wysłanego do ERP */
  PERM_24 = 'PERM-24',
  /** Widok listy stacji roboczych */
  PERM_25 = 'PERM-25',
  /** Zarządzanie zadaniem */
  PERM_26 = 'PERM-26',
  /** Wstrzymywanie zadania */
  PERM_27 = 'PERM-27',
  /** Widok komentarzy stacji roboczej */
  PERM_28 = 'PERM-28',
  /** Edycja raportu przestoju produkcji */
  PERM_29 = 'PERM-29',
  /** Edycja komentarza stacji roboczej */
  PERM_30 = 'PERM-30',
  /** Widok opisu zadania produkcyjnego */
  PERM_31 = 'PERM-31',
  /** Edycja BOM */
  PERM_32 = 'PERM-32',
  /** Widok listy szablonów technologicznych produktu */
  PERM_33 = 'PERM-33',
  /** Aktywacja szablonu technologicznego */
  PERM_34 = 'PERM-34',
  /** Edycja szablonu technologicznego */
  PERM_35 = 'PERM-35',
  /** Widok listy szablonów technologicznych grupy produktów */
  PERM_36 = 'PERM-36',
  /** Aktywacja szablonu technologicznego grupy produktów */
  PERM_37 = 'PERM-37',
  /** Widok listy kart technologicznych */
  PERM_38 = 'PERM-38',
  /** Aktywacja karty technologicznej */
  PERM_39 = 'PERM-39',
  /** Widok listy identyfikowalności */
  PERM_40 = 'PERM-40',
  /** Widok listy zamówień sprzedaży */
  PERM_41 = 'PERM-41',
  /** Widok listy ofert */
  PERM_42 = 'PERM-42',
  /** Widok listy kontrahentów */
  PERM_43 = 'PERM-43',
  /** Widok listy pracowników */
  PERM_44 = 'PERM-44',
  /** Widok szczegółów pracownika */
  PERM_45 = 'PERM-45',
  /** Edycja rejestru czasu pracy */
  PERM_46 = 'PERM-46',
  /** Widok listy kompetencji pracownika */
  PERM_47 = 'PERM-47',
  /** Widok kalendarza pracownika */
  PERM_48 = 'PERM-48',
  /** Widok listy dokumentów pracownika */
  PERM_49 = 'PERM-49',
  /** Edycja dokumentów */
  PERM_50 = 'PERM-50',
  /** Edycja kompetencji pracownika */
  PERM_51 = 'PERM-51',
  /** Edycja pracownika */
  PERM_52 = 'PERM-52',
  /** Edycja użytkownika */
  PERM_53 = 'PERM-53',
  /** Widok macierzy kompetencji pracowników */
  PERM_54 = 'PERM-54',
  /** Widok ustawień pracownika */
  PERM_55 = 'PERM-55',
  /** Widok listy produktów */
  PERM_56 = 'PERM-56',
  /** Edycja produktu */
  PERM_57 = 'PERM-57',
  /** Widok wariantów produktu */
  PERM_58 = 'PERM-58',
  /** Widok właściwości produktu */
  PERM_59 = 'PERM-59',
  /** Edycja właściwości */
  PERM_60 = 'PERM-60',
  /** Edycja cen produktu */
  PERM_61 = 'PERM-61',
  /** Widok listy maszyn */
  PERM_62 = 'PERM-62',
  /** Widok szczegółów maszyny */
  PERM_63 = 'PERM-63',
  /** Edycja zdarzenia dla maszyny */
  PERM_64 = 'PERM-64',
  /** Widok listy stanów magazynowych */
  PERM_65 = 'PERM-65',
  /** Widok listy zleceń dostaw */
  PERM_66 = 'PERM-66',
  /** Widok listy przyjęć */
  PERM_67 = 'PERM-67',
  /** Widok listy wydań */
  PERM_68 = 'PERM-68',
  /** Widok listy przesunięć magazynowych */
  PERM_69 = 'PERM-69',
  /** Widok listy inwentaryzacji */
  PERM_70 = 'PERM-70',
  /** Widok listy użytkowników */
  PERM_71 = 'PERM-71',
  /** Widok ról i uprawnień */
  PERM_72 = 'PERM-72',
  /** Dodawanie roli */
  PERM_73 = 'PERM-73',
  /** Edycja roli */
  PERM_74 = 'PERM-74',
  /** Edycja uprawnień */
  PERM_75 = 'PERM-75',
  /** Widok listy eksportów */
  PERM_76 = 'PERM-76',
  /** Synchronizacja */
  PERM_77 = 'PERM-77',
  /** Widok listy importów */
  PERM_78 = 'PERM-78',
  /** Widok listy macierzy przezbrojeń */
  PERM_79 = 'PERM-79',
  /** Edycja macierzy przezbrojeń */
  PERM_80 = 'PERM-80',
}
